import {ComponentStyleConfig, extendTheme} from '@chakra-ui/react';
import type {ThemeConfig} from '@chakra-ui/react';
import {mode, StyleConfig} from '@chakra-ui/theme-tools';
import {Dict} from '@chakra-ui/utils';
import {Button} from './components/Button';
import {Heading} from './components/Heading';
import {Popover} from './components/Popover';
import {colors, colorTokens} from './colors';
import {Link} from './components/Link';
import {Badge} from './components/Badge';
//import {Popover} from './components/Popover';

const fonts = {
  heading: `'Inter', sans-serif`,
  body: `'Inter', sans-serif`
};

const styles = {
  global: (props: Dict<any>) => ({
    body: {
      fontFamily: 'body',
      color: mode('gray.800', 'whiteAlpha.800')(props),
      bg: mode('white', 'gray.900')(props),
      lineHeight: 'base',
      WebkitFontSmoothing: 'antialiased',
      fontSize: '16px'
    },
    h1: {
      fontWeight: 600,
      fontSize: '28px',
      lineHeight: '32px'
    },
    h2: {
      fontWeight: 600,
      fontSize: '20px',
      lineHeight: '32px'
    },
    h3: {
      fontWeight: 400,
      fontSize: '28px',
      lineHeight: '32px'
    },
    h4: {
      fontWeight: 600,
      fontSize: '20px',
      lineHeight: '28px'
    },
    h5: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '20px'
    },
    p: {color: mode('gray.800', 'whiteAlpha.700')(props)},
    '*::placeholder': {
      color: mode('gray.400', 'whiteAlpha.400')(props)
    },
    '*, *::before, &::after': {
      borderColor: mode('gray.200', 'whiteAlpha.300')(props),
      wordWrap: 'break-word'
    }
  })
};

const breakpoints = {
  sm: '320px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1440px'
};

const textStyles = {
  h2: {
    fontSize: '50px'
  },
  h4: {
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: '600'
  }
};

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: true
};

const theme = extendTheme({
  config: config,
  colors: colors,
  semanticTokens: {
    colors: {
      ...colorTokens,
      text: {
        default: 'blue.900',
        _dark: 'blue.50'
      }
    }
  },
  fonts: fonts,
  textStyles: textStyles,
  components: {
    Button,
    Heading,
    Popover,
    Link,
    Badge
    //Popover
  },
  styles: styles
});

export default theme;
